import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

import { TRANSFER_LIST_QUERY_KEY } from './useTransferListQuery';
import { TRANSFER_TRAY_LIST_QUERY_KEY } from './useTransferTrayListQuery';
import { TRANSFER_STATS_QUERY_KEY } from './useTransferStatsQuery';

/**
 * This is to track the mutation key for marking a tray as received
 */
const MUT_CONFIRM_TRANSFER = 'confirm-transfer-mutation';

interface IConfirmTransferMutationParam {
  onError?: (err: IApiError) => void;
  onSuccess?: () => void;
}

/**
 * React Query mutation function for confirming inventory transfer.
 */
export const useConfirmTransferMutation = ({
  onSuccess,
  onError,
}: IConfirmTransferMutationParam) => {
  const queryClient = useQueryClient();

  const { isPending, isError, error, data, mutate, isSuccess, reset } =
    useMutation({
      mutationKey: [MUT_CONFIRM_TRANSFER],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.confirmTransfer,
      onError,
      onSuccess: () => {
        // Invalidate queries by their exact key prefix
        queryClient.invalidateQueries({
          queryKey: [TRANSFER_TRAY_LIST_QUERY_KEY],
        });
        queryClient.invalidateQueries({ queryKey: [TRANSFER_LIST_QUERY_KEY] });
        queryClient.invalidateQueries({ queryKey: [TRANSFER_STATS_QUERY_KEY] });
        onSuccess?.();
      },
    });

  return {
    isConfirmTransferError: isError,
    isConfirmTransferOngoing: isPending,
    isConfirmTransferSuccess: isSuccess,
    confirmTransferError: error,
    confirmTransfer: mutate,
    resetConfirmTransfer: reset,
    data,
  };
};
